<template>
  <div class="editCube">
    <div>{{title}} <button v-if="!edit" class="editBtn" @click="edit=true"></button></div>
    <div class="payInfo">
      <label for="payAll"><input :disabled="!edit" type="radio" id="payAll" v-model="data.type" value="全額">全額付款</label>
      <label for="payStatic"><input type="radio" :disabled="!edit" id="payStatic" v-model="data.type" value="訂金">
      預付訂金固定<input type="text" v-model="data.static" :disabled="!edit">元</label>
      <div>於預約後<input type="text" v-model="data.date" :disabled="!edit">天內預付通知完畢。</div>
    </div>
    <div class="btns" v-if="edit">
      <button class="cancel" @click="edit=false">取消</button>
      <button class="confirm" @click="udpateData">儲存</button>
    </div>
  </div>
</template>

<script>
import { getapi, postapi } from '../store/fetch'
export default {
  props: ['title'],
  data () {
    return {
      edit: false,
      data: {
        type: '全額',
        static: 0,
        date: 3
      }
    }
  },
  async mounted () {
    this.getdata()
  },
  methods: {
    async getdata () {
      this.data = await getapi('selections/PrepaidBaby')
      if (this.data === false) {
        await postapi('selections/PrepaidBaby', {
          key: 'obj',
          data: {
            type: '全額',
            static: 0,
            date: 3
          }
        })
      }
    },
    async udpateData () {
      this.data = await postapi('selections/PrepaidBaby', { key: 'obj', data: this.data })
      this.edit = false
    }
  }
}
</script>

<style lang="scss" scoped>
.payInfo {
  margin-top: 30px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  display: flex;
  flex-direction: column;
  gap: 30px;
  &>div, &>label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  input[type=radio] {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    appearance: none;
    &::before {
      border-radius: 50%;
      border: 2px solid var(--color-pri);
      display: inline-block;
      width: 24px;
      height: 24px;
      background-color: #FFFFFF;
      content: '';
      margin-right: 8px;
    }
    &:checked::before {
      background-color: var(--color-checked);
    }
    &:checked::after {
      content: '';
      display: inline-block;
      position: absolute;
      left: 6px;
      top: 6px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #FFFFFF;
    }
  }
  input[type=text] {
    width: 100px;
    height: 40px;
    text-align: center;
    margin-inline: 12px;
    border: 1px solid var(--color-border);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    text-align: center;
    letter-spacing: 0.1em;
    color: #E37878;
  }
}
.editCube {
  margin: 0;
  margin-bottom: 60px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    margin: 0;
    padding: 7px 20px;
    height: 200px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
  }
  textarea {
    border: 1px solid var(--color-border);
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: 20px;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(./pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
